import React, { forwardRef } from 'react';
import { RadioGroup, Radio } from '@fiverr-private/forms';

interface OptionType {
  text: string;
  value: string;
}

interface FormRadioGroupProps {
  name: string;
  value?: string;
  onChange?: (value: string) => void;
  direction?: 'column' | 'row' | 'rowReverse' | 'columnReverse';
  options?: OptionType[];
  disabled?: boolean;
  isRequired?: boolean;
  children?: React.ReactNode;
  valid?: boolean;
}

export const FormRadioGroup = forwardRef<HTMLDivElement, FormRadioGroupProps>(
  (
    {
      name,
      value,
      onChange,
      direction = 'column',
      options = [],
      disabled = false,
      children,

      valid: _valid,
      ...rest
    },
    _ref
  ) => {
    const handleChange = (newValue: string) => {
      if (onChange) {
        onChange(newValue);
      }
    };

    return (
      <RadioGroup name={name} value={value} onChange={handleChange} direction={direction} disabled={disabled} {...rest}>
        {options.length > 0
          ? options.map(({ text, value: optionValue }) => (
              <Radio key={optionValue} value={optionValue}>
                {text}
              </Radio>
            ))
          : children}
      </RadioGroup>
    );
  }
);

FormRadioGroup.displayName = 'FormRadioGroup';
